import React from 'react';
import { Card, Row } from 'reactstrap';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';

import { TotalRegister } from 'components/TotalRegister';
import { individual_column_style } from '../../../../assets/styles/table_custom_style';

const OverallAverageQuestionnaire = ({ data, totalRegister }) => {
  return (
    <>
      <Row className="mt-3">
        <div className="col">
          <div className="card-wrapper">
            <TotalRegister totalRegister={totalRegister} />
            <Card>
              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: 'agent',
                    text: 'Agente',
                    align: 'center',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: {
                      whiteSpace: 'break-spaces',
                      textAlign: 'center',
                      cursor: 'pointer'
                    }
                  },
                  {
                    dataField: 'author',
                    text: 'Autor',
                    align: 'center',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: {
                      whiteSpace: 'break-spaces',
                      textAlign: 'center',
                      cursor: 'pointer'
                    }
                  },
                  {
                    dataField: 'paper_name',
                    text: 'Tipo de questionário',
                    align: 'center',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: {
                      whiteSpace: 'break-spaces',
                      textAlign: 'center',
                      cursor: 'pointer'
                    }
                  },
                  {
                    dataField: 'tma',
                    text: 'tma',
                    align: 'center',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: {
                      whiteSpace: 'break-spaces',
                      textAlign: 'center',
                      cursor: 'pointer'
                    }
                  },
                  {
                    dataField: 'call_count',
                    text: 'Quantidade de Ligações Atendidas',
                    align: 'center',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: {
                      whiteSpace: 'break-spaces',
                      textAlign: 'center',
                      cursor: 'pointer'
                    }
                  },

                  {
                    dataField: 'overall_average',
                    text: 'Nota Média',
                    align: 'center',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: {
                      whiteSpace: 'break-spaces',
                      textAlign: 'center',
                      cursor: 'pointer'
                    }
                  }
                ]}
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <BootstrapTable
                      {...props.baseProps}
                      bootstrap4={true}
                      bordered={false}
                      classes="align-items-center"
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </div>
        </div>
      </Row>
    </>
  );
};

export default OverallAverageQuestionnaire;
